import type { CellKindConversionRejection } from './transaction-builders/cellKindConversion';
import type { FragmentHealthFailure } from './utils/adfConversion';

/** The observed result of the final commit, independent of document deltas. */
export type CommitOutcome =
	| { applied: true }
	| {
			applied: false;
			health?: undefined;
			reason: 'cellConversionRejected';
			rejection: CellKindConversionRejection;
	  }
	| {
			applied: false;
			health?: FragmentHealthFailure;
			reason:
				| 'noSessionState'
				| 'noStreamingState'
				| 'noPositions'
				| 'noRange'
				| 'unhealthyFragment'
				| 'noFragment'
				| 'commitBuildError'
				| 'finalizeThrew';
	  };

export type CommitRejection = Extract<CommitOutcome, { applied: false }>;

export type CommitRejectionAttributes = {
	contentApplied: false;
	contentDroppedDetail?: FragmentHealthFailure['reason'] | CellKindConversionRejection['reason'];
	contentDroppedMarkTypes?: string;
	contentDroppedNodeType?: string;
	contentDroppedReason: CommitRejection['reason'];
};

/** Schema identifiers and bounded reasons only; never fragment content or attributes. */
export function commitAttributes(
	outcome: CommitOutcome | undefined,
): CommitRejectionAttributes | undefined {
	if (!outcome || outcome.applied) {
		return undefined;
	}
	return {
		contentApplied: false,
		contentDroppedReason: outcome.reason,
		...(outcome.reason === 'cellConversionRejected'
			? { contentDroppedDetail: outcome.rejection.reason }
			: {}),
		...(outcome.health
			? {
					contentDroppedNodeType: outcome.health.nodeType,
					contentDroppedDetail: outcome.health.reason,
					...(outcome.health.markTypes
						? { contentDroppedMarkTypes: outcome.health.markTypes }
						: {}),
				}
			: {}),
	};
}
